import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { TimezoneDisplayMode } from "features/integrationsBeta/timezoneDisplay";

/**
 * Local / UTC / Client switch for run-timestamp display. "Client" renders
 * each timestamp in the owning integration's timezone (grey abbreviation
 * next to the time).
 */
export default function TimezoneDisplayToggle({
  mode,
  onChange,
  height,
}: {
  mode: TimezoneDisplayMode;
  onChange: (mode: TimezoneDisplayMode) => void;
  /** Pin the group to a control row height (e.g. FILTER_FIELD_H = 40). */
  height?: number;
}) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(_, next: TimezoneDisplayMode | null) => {
        if (next) onChange(next);
      }}
      aria-label="Timestamp timezone"
      sx={{
        ...(height ? { height } : {}),
        "& .MuiToggleButton-root": {
          px: 1.5,
          py: 0.5,
          ...(height ? { height } : {}),
        },
      }}
    >
      <ToggleButton value="local">Local</ToggleButton>
      <ToggleButton value="utc">UTC</ToggleButton>
      <ToggleButton value="client">Client</ToggleButton>
    </ToggleButtonGroup>
  );
}
